import cn from "classnames";
import styles from "./CallingLineMoreInfoAboutCall.module.scss";
import { FC } from "react";
import { ICallingLineMoreInfoAboutCall } from "./CallingLineMoreInfoAboutCall.props";
import { BlockWithLabel } from "@/ui";
import { useTranslate } from "@/hooks";
import AudioData from "@/components/DialogueArchive/AudioData/AudioData";
import Messages from "@/components/DialogueArchive/Messages/Messages";
import { Button } from "@mui/material";
import H3 from "@/ui/H3/H3";

const CallingLineMoreInfoAboutCall: FC<ICallingLineMoreInfoAboutCall> = ({ callData, selectedDialogue, setCallData }) => {
	const translate = useTranslate();
	return (
		<div className={cn(styles["more-info-section"])}>
			<div className={cn(styles["more-info-section-content"])}>
				<H3>{translate("title_callInfo")}</H3>
				<BlockWithLabel label={translate("title_callData")} sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", textAlign: "left", gap: "12px" }}>
					{Object.entries(callData.metadata).map(([key, value]) => (
						<p key={key}>
							<span className={cn(styles["typography-bold"])}>{`${translate(key)}:`}</span> {`${value}`}
						</p>
					))}
				</BlockWithLabel>
				{selectedDialogue.channelList[0] === "voice" ? (
					<BlockWithLabel label={translate("title_callAudio")} sx={{ paddingBottom: "18px" }}>
						<AudioData selectedDialogue={selectedDialogue} />
					</BlockWithLabel>
				) : (
					<></>
				)}
				<BlockWithLabel
					label={selectedDialogue.channelList[0] === "voice" ? translate("title_callDecoding") : translate("title_callMessages")}
					sx={{ maxHeight: "480px" }}
				>
					<Messages selectedDialogue={selectedDialogue} service="cls" />
				</BlockWithLabel>
			</div>
			<Button onClick={() => setCallData(undefined)} variant="outlined" sx={{ marginTop: "auto", fontSize: 11 }}>
				{translate("button_close")}
			</Button>
		</div>
	);
};

export default CallingLineMoreInfoAboutCall;
